import { graphql } from '@/gql';
import type { UpdateDriverConfirmedMonitoringCallMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const updateDriverConfirmedMonitoringCall = async ({
  id,
  isConfirmed,
  notes,
}: UpdateDriverConfirmedMonitoringCallMutationVariables) => {
  const response = await mutationExecute({
    variables: {
      id,
      isConfirmed,
      notes,
    },
    mutation: graphql(`
      mutation UpdateDriverConfirmedMonitoringCall($id: String!, $isConfirmed: Boolean!, $notes: String) {
        updateDriverConfirmedMonitoringCall(id: $id, isConfirmed: $isConfirmed, notes: $notes) {
          id
        }
      }
    `),
  });

  return response.data?.updateDriverConfirmedMonitoringCall;
};
